import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Page } from '../AppRouter';
import { useAlerts } from '../../pages/Alerts/queries';

interface TopNavigationProps {
  currentPage: Page;
  onPageChange: (page: Page) => void;
}

const TopNavigation: React.FC<TopNavigationProps> = ({ currentPage, onPageChange }) => {
  const { data: alerts = [] } = useAlerts();
  const unreadCount = alerts.filter(alert => !alert.isRed).length;
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const menuItems = [
    {
      id: 'dashboard' as Page,
      label: 'Dashboard',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 13.1111H10.8889V2H2V13.1111ZM2 22H10.8889V15.3333H2V22ZM13.1111 22H22V10.8889H13.1111V22ZM13.1111 2V8.66667H22V2H13.1111Z" fill="currentColor"/>
        </svg>
      ),
    },
    {
      id: 'staffs' as Page,
      label: 'Staffs',
      icon: (
        <svg width="24" height="24" viewBox="0 0 29 26" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16 25V22C16 17.8579 12.6421 14.5 8.5 14.5C4.35787 14.5 1 17.8579 1 22V25H16ZM16 25H28V23.5C28 19.0818 24.6421 16 20.5 16C18.3801 16 16.4655 16.9382 15.1013 18.4466M13 5.5C13 7.98527 10.9853 10 8.5 10C6.01473 10 4 7.98527 4 5.5C4 3.01472 6.01473 1 8.5 1C10.9853 1 13 3.01472 13 5.5ZM23.5 8.5C23.5 10.1569 22.1569 11.5 20.5 11.5C18.8431 11.5 17.5 10.1569 17.5 8.5C17.5 6.84314 18.8431 5.5 20.5 5.5C22.1569 5.5 23.5 6.84314 23.5 8.5Z" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
    },
    {
      id: 'attendance' as Page,
      label: 'Attendance',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_attendance_new)">
            <path d="M15.0227 15.745L17.1325 17.8262L20.9501 13.9661C20.8861 13.9549 20.8189 13.9491 20.7494 13.9491H13.6195C13.3082 13.9491 13.0243 14.0771 12.8189 14.2826C12.6134 14.488 12.4854 14.7718 12.4854 15.0832V21.8314C12.5101 21.8723 12.5242 21.92 12.5242 21.9709C12.5242 22.0218 12.5101 22.0694 12.4854 22.1104V22.2131C12.4854 22.5245 12.6134 22.8083 12.8189 23.0138C13.0243 23.2192 13.3082 23.3472 13.6195 23.3472H20.7494C21.0614 23.3472 21.345 23.2198 21.5498 23.0147C21.7562 22.8086 21.8835 22.5251 21.8835 22.2131V16.0922L17.3437 20.6845C17.2394 20.7907 17.0678 20.792 16.9616 20.6877L13.5085 17.281C13.4022 17.1766 13.401 17.0051 13.5053 16.8989L14.6406 15.7482C14.745 15.6419 14.9165 15.6406 15.0227 15.745ZM16.9459 18.4013L14.8358 16.3197L14.08 17.0858L17.1488 20.1133L23.7306 13.4547L22.9651 12.6992L17.328 18.399C17.223 18.5043 17.0518 18.5056 16.9459 18.4013ZM11.9434 21.6998V15.0832C11.9434 14.6224 12.1322 14.2026 12.4355 13.8992C12.7389 13.5958 13.1587 13.407 13.6195 13.407H17.3178C16.6454 12.4022 15.7456 11.56 14.6941 10.9565C13.5565 10.3034 12.2394 9.92928 10.8394 9.92928H7.78784C5.65344 9.92928 3.712 10.7997 2.29472 12.2093C0.87648 13.6282 0 15.5754 0 17.7168V20.1802C0 20.5981 0.1712 20.9782 0.4464 21.2534C0.7216 21.5286 1.10176 21.6998 1.51936 21.6998H11.9434ZM12.3872 1.27296C11.601 0.48672 10.5139 0 9.31392 0C8.12096 0 7.04 0.48064 6.24768 1.2656C5.4544 2.0592 4.96768 3.14624 4.96768 4.34624C4.96768 5.54624 5.4544 6.63296 6.24064 7.4192C7.0272 8.20576 8.11392 8.69248 9.31392 8.69248C10.5139 8.69248 11.601 8.20576 12.3872 7.41952C13.1738 6.6336 13.6602 5.54656 13.6602 4.34624C13.6602 3.14624 13.1734 2.0592 12.3872 1.27296Z" fill="currentColor"/>
          </g>
          <defs>
            <clipPath id="clip0_attendance_new">
              <rect width="24" height="24" fill="white"/>
            </clipPath>
          </defs>
        </svg>
      ),
    },
    // {
    //   id: 'roles' as Page,
    //   label: 'Roles',
    //   icon: (
    //     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    //       <path d="M18.2156 12.6C17.0715 12.6 15.9532 12.9343 15.0019 13.5606C14.0507 14.1869 13.3093 15.0772 12.8715 16.1187C12.4337 17.1602 12.3191 18.3063 12.5423 19.412C12.7655 20.5177 13.3164 21.5333 14.1254 22.3305C14.9343 23.1277 15.965 23.6705 17.0871 23.8905C18.2092 24.1104 19.3722 23.9975 20.4292 23.5661C21.4861 23.1347 22.3896 22.4041 23.0252 21.4667C23.6608 20.5294 24 19.4273 24 18.3C23.992 16.7907 23.38 15.3454 22.2969 14.2782C21.2139 13.2109 19.7472 12.6079 18.2156 12.6ZM19.2304 18.8C19.073 18.7962 18.9179 18.7622 18.7737 18.7L16.5919 20.85C16.4695 20.9693 16.3071 21.0405 16.1352 21.05C16.0481 21.0583 15.9602 21.0443 15.8802 21.0092C15.8001 20.9742 15.7307 20.9193 15.6786 20.85C15.5562 20.7212 15.4881 20.5514 15.4881 20.375C15.4881 20.1986 15.5562 20.0288 15.6786 19.9L17.8604 17.75C17.8026 17.6062 17.7683 17.4543 17.7589 17.3C17.7358 17.0616 17.763 16.821 17.8388 16.5935C17.9146 16.366 18.0374 16.1564 18.1995 15.9779C18.3615 15.7994 18.5593 15.6559 18.7804 15.5565C19.0015 15.457 19.2411 15.4037 19.4841 15.4C19.6415 15.4038 19.7966 15.4378 19.9408 15.5C20.0422 15.5 20.0422 15.6 19.9915 15.65L18.9767 16.6C18.9532 16.6117 18.9335 16.6295 18.9197 16.6516C18.9059 16.6737 18.8986 16.6991 18.8986 16.725C18.8986 16.7509 18.9059 16.7763 18.9197 16.7984C18.9335 16.8205 18.9532 16.8383 18.9767 16.85L19.6363 17.5C19.6543 17.5228 19.6774 17.5413 19.7038 17.554C19.7302 17.5668 19.7592 17.5734 19.7885 17.5734C19.8179 17.5734 19.8469 17.5668 19.8733 17.554C19.8996 17.5413 19.9227 17.5228 19.9408 17.5L20.9048 16.55C20.9556 16.5 21.1078 16.5 21.1078 16.6C21.1605 16.7453 21.1946 16.8964 21.2093 17.05C21.2054 17.296 21.1501 17.5386 21.0466 17.7625C20.9431 17.9864 20.7937 18.1868 20.6079 18.3511C20.4221 18.5155 20.2038 18.6402 19.9668 18.7174C19.7297 18.7946 19.479 18.8228 19.2304 18.8Z" fill="currentColor"/>
    //       <path d="M9.79309 12.9C13.4081 12.9 16.3386 10.0122 16.3386 6.45C16.3386 2.88776 13.4081 0 9.79309 0C6.17809 0 3.24756 2.88776 3.24756 6.45C3.24756 10.0122 6.17809 12.9 9.79309 12.9Z" fill="currentColor"/>
    //       <path d="M11.5688 23.9C12.6851 23.9 12.0763 23.15 12.0763 23.15C10.956 21.7749 10.3471 20.0634 10.3511 18.3C10.3457 17.1948 10.5883 16.1021 11.0614 15.1C11.0827 15.0428 11.1175 14.9914 11.1629 14.95C11.5181 14.25 10.8077 14.2 10.8077 14.2C10.4882 14.1584 10.1659 14.1417 9.84367 14.15C7.45474 14.1592 5.14822 15.0116 3.3423 16.5526C1.53638 18.0937 0.35062 20.2214 0 22.55C0 23.05 0.152222 23.95 1.72518 23.95H11.4166C11.5181 23.9 11.5181 23.9 11.5688 23.9Z" fill="currentColor"/>
    //     </svg>
    //   ),
    // },
    {
      id: 'workShifts' as Page,
      label: 'Work Shifts',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_3520_1022)">
            <path d="M12.9045 6.57171V11.2317L16.7684 13.5498C17.6738 14.0707 17.6758 15.3764 16.7719 15.9001C16.3373 16.1519 15.7991 16.143 15.373 15.8769L10.8498 13.1631C10.4409 12.9179 10.1907 12.4762 10.1906 11.9995V6.57171C10.1906 5.52713 11.3214 4.87428 12.226 5.39656C12.6458 5.63896 12.9045 6.08692 12.9045 6.57171ZM22.4031 3.40551C21.6537 3.40551 21.0461 4.01303 21.0461 4.76245V5.59584C20.5701 5.06776 20.0759 4.54308 19.5433 4.0037C13.3878 -2.15119 2.87768 0.665597 0.625176 9.07391C-1.62733 17.4822 6.06712 25.1758 14.4752 22.9224C16.2853 22.4373 17.9464 21.5099 19.3092 20.2237C20.0692 19.5064 19.7677 18.2355 18.7665 17.936C18.3019 17.797 17.7984 17.9164 17.4457 18.2493C12.6344 22.79 4.71184 20.4195 3.1852 13.9824C1.65855 7.54528 7.67276 1.86946 14.0108 3.76589C15.3728 4.17344 16.6125 4.91255 17.6187 5.91698C18.2881 6.59433 18.8976 7.25018 19.489 7.92865H17.8799C16.8354 7.92865 16.1825 9.05944 16.7048 9.96407C16.9472 10.3839 17.3952 10.6425 17.8799 10.6425H22.4031C23.1525 10.6425 23.76 10.035 23.76 9.2856V4.76245C23.76 4.01303 23.1525 3.40551 22.4031 3.40551Z" fill="currentColor"/>
          </g>
          <defs>
            <clipPath id="clip0_3520_1022">
              <rect width="24" height="24" fill="white"/>
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      id: 'sites' as Page,
      label: 'Sites',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 1C9.23855 1 7 3.03706 7 5.55C7 8.06287 11.6429 13.9982 12 14C12.3571 14.0016 17 8.06287 17 5.55C17 3.03706 14.7614 1 12 1ZM12 3.93007C12.982 3.93007 13.7857 4.66144 13.7857 5.55507C13.7857 6.44869 12.982 7.18007 12 7.18007C11.018 7.18007 10.2143 6.44869 10.2143 5.55507C10.2143 4.66144 11.018 3.93007 12 3.93007Z" fill="#EE3B2B"/>
          <path d="M23.507 16.3033C23.8249 16.1132 24.0132 15.7695 23.9993 15.4047C23.9854 15.0399 23.7714 14.7109 23.4399 14.5446L16.5946 11.1109C16.0889 10.8572 15.4692 11.0535 15.2105 11.5493C14.9517 12.0451 15.1519 12.6527 15.6576 12.9064L20.867 15.5195L12.018 20.8109L3.13851 15.5196L8.36475 12.9071C8.87083 12.6541 9.07192 12.0468 8.81389 11.5506C8.55584 11.0544 7.93643 10.8573 7.43035 11.1103L0.561364 14.544C0.229148 14.71 0.0146305 15.0394 0.000718522 15.4047C-0.0131908 15.7701 0.175684 16.1142 0.494348 16.3041L11.4847 22.8533C11.8134 23.0492 12.2261 23.0489 12.5545 22.8525L23.507 16.3033Z" fill="currentColor"/>
        </svg>
      ),
    },
    {
      id: 'alerts' as Page,
      label: 'Alerts',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19.3333 8.20128C19.3333 6.29138 18.5607 4.45971 17.1854 3.10921C15.8102 1.7587 13.9449 1 12 1C10.0551 1 8.18982 1.7587 6.81455 3.10921C5.43928 4.45971 4.66667 6.29138 4.66667 8.20128C4.66667 16.6028 1 19.0032 1 19.0032H23C23 19.0032 19.3333 16.6028 19.3333 8.20128Z" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M14.1141 23.804C13.8993 24.1677 13.5908 24.4697 13.2198 24.6795C12.8487 24.8894 12.4279 24.9999 11.9997 24.9999C11.5715 24.9999 11.1507 24.8894 10.7796 24.6795C10.4086 24.4697 10.1001 24.1677 9.88525 23.804" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      badge: unreadCount > 0,
    },
  ];

  const activeItem = menuItems.find(item => item.id === currentPage);

  return (
    <>
      {/* Mobile nav */}
      <nav className="bg-[#183059] px-4 py-2 md:hidden">
        <div className="flex items-center justify-between h-12">
          <span className="text-white font-medium text-sm">
            {activeItem?.label || 'Menu'}
          </span>
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="text-white p-1"
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="pb-2 border-t border-[#1f3a6b] mt-1 pt-2 space-y-1">
            {menuItems.map((item) => {
              const isActive = currentPage === item.id;
              return (
                <button
                  key={item.id}
                  onClick={() => { onPageChange(item.id); setIsMobileMenuOpen(false); }}
                  className={`relative flex items-center gap-3 w-full px-3 py-2.5 rounded transition-colors ${
                    isActive ? 'bg-[#F9E719] text-[#1F242E]' : 'text-white hover:bg-[#1f3a6b]'
                  }`}
                >
                  <div className={isActive ? 'text-[#1F242E]' : 'text-white'}>
                    {item.icon}
                  </div>
                  <span className="text-sm font-medium">{item.label}</span>
                  {item.badge && unreadCount > 0 && (
                    <span className="ml-auto min-w-[18px] h-[18px] flex items-center justify-center bg-red-500 rounded-full text-white text-[10px] font-bold px-1">
                      {unreadCount > 99 ? '99+' : unreadCount}
                    </span>
                  )}
                </button>
              );
            })}
          </div>
        )}
      </nav>

      {/* Desktop nav */}
      <nav className="hidden md:block bg-[#183059] px-6 py-2">
        <div className="flex items-center justify-start gap-4">
          {menuItems.map((item) => {
            const isActive = currentPage === item.id;
            return (
              <button
                key={item.id}
                onClick={() => onPageChange(item.id)}
                className={`relative p-2 rounded transition-colors flex items-center justify-center border-t-[0.5px] border-transparent flex-1 h-12 ${
                  isActive ? 'bg-[#F9E719]' : 'hover:bg-[#1f3a6b]'
                }`}
                title={item.label}
              >
                <div className={`relative ${isActive ? 'text-[#1F242E]' : 'text-white'}`}>
                  {item.icon}
                  {item.badge && unreadCount > 0 && (
                    <span className="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] flex items-center justify-center bg-red-500 rounded-full border-2 border-[#183059] text-white text-[10px] font-bold px-1">
                      {unreadCount > 99 ? '99+' : unreadCount}
                    </span>
                  )}
                </div>
              </button>
            );
          })}
        </div>
      </nav>
    </>
  );
};

export default TopNavigation;
